import type { ColDef, ColGroupDef, GridOptions, ValueFormatterParams } from 'ag-grid-community';

import { TableHeaderWithTooltipIcon } from '~/components/common';
import {
  SettlementStorageDetailCustomHeaderGroup as CustomHeaderGroup,
  SettlementStorageDetailCustomHeaderChildren as CustomHeaderGroupChildren,
} from '~/components/settlement';

import { formatNumber } from '~/utils';

import type { TypeGetStorageFeeDailySkusResponse } from '~/types/settlement.types';

/**
 * [정산관리][보관비 조회] 일자 별 보관비 상세 모달 컬럼 정의
 */
const getSettlementStorageDailyFeeDetailColumnDefs = () => {
  const gridOptions: GridOptions = {
    suppressRowVirtualisation: false,
    columnTypes: {
      number: {
        cellStyle: { textAlign: 'right' },
        valueFormatter: ({ value }: ValueFormatterParams) => {
          return value !== null && value !== undefined ? formatNumber(value) : '-';
        },
      },
      customHeaderGroupChildren: { headerComponent: CustomHeaderGroupChildren },
    },
  };

  const columnDefs: (
    | ColDef<TypeGetStorageFeeDailySkusResponse['data'][number]>
    | ColGroupDef<TypeGetStorageFeeDailySkusResponse['data'][number]>
  )[] = [
    {
      headerName: 'No',
      headerGroupComponent: CustomHeaderGroup,
      children: [{ headerName: '', valueGetter: 'node.rowIndex + 1', width: 72 }],
    },
    {
      headerName: '상품명',
      headerGroupComponent: CustomHeaderGroup,
      children: [{ field: 'skuName', headerName: '', width: 240 }],
    },
    {
      headerName: 'SKU코드',
      headerGroupComponent: CustomHeaderGroup,
      children: [{ field: 'skuCode', headerName: '', width: 140 }],
    },
    {
      headerName: '상품바코드',
      headerGroupComponent: CustomHeaderGroup,
      children: [{ field: 'skuBarcode', headerName: '', width: 140 }],
    },
    {
      headerName: '총 보관비',
      headerGroupComponent: CustomHeaderGroup,
      children: [{ field: 'totalStorageFee', headerName: '', width: 100, type: 'number' }],
    },
    {
      headerName: '실 과금액',
      headerGroupComponent: CustomHeaderGroup,
      children: [{ field: 'chargedStorageFee', headerName: '', width: 100, type: 'number' }],
    },
    {
      headerName: '구간별 과금액(원)',
      headerGroupComponent: CustomHeaderGroup,
      headerGroupComponentParams: { align: 'center' },
      children: [
        {
          field: 'storageFeePerRange.RANGE_001',
          headerName: '30일 이하',
          width: 100,
          type: ['number', 'customHeaderGroupChildren'],
        },
        {
          field: 'storageFeePerRange.RANGE_002',
          headerName: '31~60일',
          width: 100,
          type: ['number', 'customHeaderGroupChildren'],
        },
        {
          field: 'storageFeePerRange.RANGE_003',
          headerName: '61~90일',
          width: 100,
          type: ['number', 'customHeaderGroupChildren'],
        },
        {
          field: 'storageFeePerRange.RANGE_004',
          headerName: '91일 이상',
          width: 100,
          type: ['number', 'customHeaderGroupChildren'],
        },
      ],
    },
    {
      headerName: '시점 재고',
      headerGroupComponent: TableHeaderWithTooltipIcon,
      headerGroupComponentParams: {
        tooltipDescription: '조회 날짜 기준\n보관비가 부과된 재고입니다.',
        tooltipMaxWidth: '158px',
      },
      children: [{ field: 'quantity', headerName: '', width: 100, type: 'number' }],
    },
    {
      headerName: 'CBM(㎥)',
      headerGroupComponent: CustomHeaderGroup,
      children: [
        {
          field: 'cbm',
          headerName: '',
          width: 112,
          type: 'number',
        },
      ],
    },
  ];

  return { gridOptions, columnDefs };
};

export default getSettlementStorageDailyFeeDetailColumnDefs;
